import { Button, DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, cn } from "ui";
import { MoreVertical } from "lucide-react";
import type { Translator } from "../types/nav";
import { useRewardsAdmin } from "../host/RewardsAdminHost";

export interface IRowAction {
  key: string;
  label: string;
  onSelect: () => void;
  /** Renders the item in the error color (archive, cancel, reverse...). */
  destructive?: boolean;
}

export interface IRowActionsMenuProps {
  /** Visible actions; falsy entries are skipped so callers can inline conditions. */
  actions: (IRowAction | false | null | undefined)[];
  t?: Translator;
}

/** Kebab menu of row actions shared by every rewards table. Renders nothing without actions. */
export function RowActionsMenu({ actions, t: tOverride }: IRowActionsMenuProps) {
  const { t } = useRewardsAdmin({ t: tOverride });
  const visibleActions = actions.filter((action): action is IRowAction => Boolean(action));
  if (visibleActions.length === 0) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="icon" size="icon" aria-label={t("rewards.action.menu")} data-testid="row-actions">
          <MoreVertical className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {visibleActions.map((action) => (
          <DropdownMenuItem
            key={action.key}
            onSelect={action.onSelect}
            className={cn(action.destructive && "text-ticketon-error-text")}
            data-testid={`row-action-${action.key}`}
          >
            {action.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
